import { Controller } from "@hotwired/stimulus"

// Copia al portapapeles el valor del target `source` y confirma en el propio
// botón durante un momento.
// Uso: data-controller="clipboard", data-clipboard-target="source" en el
// campo y data-action="click->clipboard#copy" en el botón.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy(event) {
    event.preventDefault()
    const value = this.sourceTarget.value ?? this.sourceTarget.textContent
    try {
      await navigator.clipboard.writeText(value)
    } catch {
      this.sourceTarget.select?.()
      document.execCommand("copy")
    }
    const button = this.hasButtonTarget ? this.buttonTarget : event.currentTarget
    const original = button.innerHTML
    button.innerHTML = '<i class="fas fa-check"></i>'
    setTimeout(() => { button.innerHTML = original }, 1500)
  }
}
